// src/components/ambassadors/StepCard.tsx

import { motion } from "framer-motion";

interface StepCardProps {
  number: string;
  title: string;
  description: string;
}

export function StepCard({ number, title, description }: StepCardProps) {
  return (
    <motion.div whileHover={{ scale: 1.02 }} className="relative group">
      <div className="absolute inset-0 bg-gradient-to-r from-amber-500/20 to-rose-500/20 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 md:p-8">
        <div className="flex items-center gap-4 mb-6">
          <span className="text-4xl md:text-5xl font-black text-amber-400/30">{number}</span>
        </div>
        <h3 className="text-lg md:text-xl font-black text-white mb-3">{title}</h3>
        <p className="text-xs md:text-sm text-white/60 leading-relaxed">{description}</p>
      </div>
    </motion.div>
  );
}
